import React, { useState } from 'react'
import Select from "react-select"
import { Select as AntSelect } from 'antd'
import { useParams } from 'react-router-dom'

import { useListData, usePet, useToggle } from '../modules'

import FilterButton from '../partials/actions/FilterButton'

import Receive from '../components/resusable/receive'
import NewSaleItem from '../components/modals/newsaleitem'

const { Option } = AntSelect

const Station = () => {
    const { id } = useParams()

    const [category, setCategory] = useState()

    const [saleItemModal, toggleSaleItemModal] = useToggle()

    const [
        { loading: itemsLoading, error: itemsError, fetch: fetchItems }, 
        { list: saleItems }, 
        { Paginate }
    ] = useListData('saleItemsByStation', { 
        station: id,
        category: category?.label
     }, { notify: true }, 'items')

    const [{ loading: statLoading, error: statError, data: station }] = usePet('station', { id }, { notify: true })

    const [{ loading: catsLoading, error: catsError, data: categories = [] }, fetchCats] = usePet('saleItemCategoriesByStation', { station: id }, { notify: true })

    const changeCategory = val => {
        setCategory(val)
        fetchItems()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <Receive
                loading={ statLoading }
                error={ statError }
                condition={ station }>
                <NewSaleItem
                    onPerform={ () => {
                        fetchItems()
                        fetchCats()
                     } }
                    station={ station }
                    toggle={toggleSaleItemModal}
                    visible={saleItemModal} />
            </Receive>
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    {/* Filter button */}
                    {/* <FilterButton
                        options={['prepared', 'sale items', 'service']} /> */}
                    <button onClick={toggleSaleItemModal} className="btn hisani-btn-green text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">New Item/Service</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <Receive
                    error={statError}
                    loading={statLoading}
                    progress>
                    <>
                        <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                            <h2 className="font-semibold text-gray-800">{station?.name}</h2>
                            <Receive
                                error={catsError}
                                loading={catsLoading}
                                progress>
                                <Select
                                    isClearable
                                    value={ category }
                                    onChange={ changeCategory }
                                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                    options={categories?.map(category => ({ label: category, value: category }))}
                                    placeholder="Category" />
                            </Receive>
                        </header>
                        <div className="p-3">
                            <div className="overflow-x-auto">
                                <Receive
                                    error={itemsError}
                                    loading={itemsLoading}
                                    progress>
                                    {
                                        saleItems.length > 0 ?
                                            <table className="table-auto w-full">
                                                {/* Table header */}
                                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">No</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Item</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Category</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Price</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Status</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Opened On</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center"></div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {/* Table body */}
                                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                    {
                                                        saleItems.map((item, key) =>
                                                            <tr>
                                                                <td className="p-2">
                                                                    <div className="text-center">{key + 1}.</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="">{item.name}</div>
                                                                    <p className="text-gray-500 text-xs italic">{item.type}</p>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{item.category}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{item.price ? `Ksh. ${item.price}` : `${item.variants.length} variants`}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center text-green-500">Available</div>
                                                                </td>
                                                                <td className="p-2 text-center">
                                                                    <AntSelect onChange={ val => typeof(val) === 'function' ? val() : null } style={{ minWidth: '10em' }} placeholder="Actions">
                                                                        <Option value={ () => null }>View</Option>
                                                                        <Option value={ null }>Make Unavailable</Option>
                                                                    </AntSelect>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        :
                                            <div className="flex font-semibold text-md justify-center items-center">
                                                <h2>Please click above to add some items</h2>
                                            </div>
                                    }
                                </Receive>
                                {Paginate}
                            </div>
                        </div>
                    </>
                </Receive>
            </div>
        </div>
    )
}

export default Station